/**
 * A select option stores either an explicit `value` or, when the editor left that blank,
 * falls back to its visible `label`.
 *
 * One definition because the copies drifted: two of them read a `label_de` that is not in
 * the GraphQL selection set, so an option with an empty `value` would stop matching. In
 * `serializeValue` that line sits behind an `isNotYetAnswered` guard which no CMS data can
 * satisfy today, so it was latent rather than live — but latent is only one schema change
 * away from live, which is the argument for having one definition.
 */
function getOptionValue(option) {
  return option.value || option.label;
}

module.exports = getOptionValue;
